import { GTMEvent } from "@/helpers/gtm/GTMEvent.ts";
import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import TagManager from "react-gtm-module";

export const useGTMBeginCheckout = () => {
  const cartAccommodationItems = useEngineStore((state) => state.cartAccommodationItems);

  return () => {
    const checkoutItems = cartAccommodationItems?.map((cartItem, index) => {
      const RP = cartItem.ratePlan;
      const RG = cartItem.ratePlan.rateGroup;

      return {
        item_id: RP.id,
        item_name: RP.name,
        currency: "EUR",
        price: RP.defaultPriceBreakdown.withDiscount,
        item_category: RG.name,
        index,
        quantity: 1,
      };
    });

    const totalValue = (checkoutItems ?? []).reduce((acc, item) => acc + item.price, 0);

    TagManager.dataLayer({ dataLayer: { ecommerce: null } });
    TagManager.dataLayer({
      dataLayer: {
        event: GTMEvent.BeginCheckout,
        ecommerce: {
          currency: "EUR",
          value: totalValue,
          items: checkoutItems ?? [],
        },
      },
    });
  };
};
